import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { useUser } from '../../hooks/useUser'
import UserContext from '../../contexts/UserContext/context'
import { removeUser } from '../../contexts/UserContext/actions'
import { decodeToken } from '../../services/utils/misc'
import AdminToolsWidget from '../AdminToolsWidget'
import LangSelect from '../LangSelect'
import UserProfileWidget from '../UserProfileWidget'
import './index.scss'
import Button from '../Button'
import Icon from '../Icon'
import { ICON } from '../Icon/data'

const Header = () => {
  const { t } = useTranslation()
  const { isAdmin } = useUser();
  const { user, dispatch } = useContext(UserContext)

  // Set by the backend when an admin logged in as this user from Django admin
  const isImpersonating = !!decodeToken(user.access_token)?.impersonator_id

  const stopImpersonating = () => {
    localStorage.removeItem('access_token')
    localStorage.removeItem('refresh_token')
    dispatch(removeUser())
  }

  const backToThePast = () => {
    const { DEV, PROD } = import.meta.env
    if (DEV) window.location.href = 'https://floti-staging.trackwell.com/'
    else if (PROD) window.location.href = 'https://floti.trackwell.com/'
  }

  return (
    <div className="Header">
      <div className="Header__left">
        <Button
          size="s"
          type="tertiary"
          label={(
            <>
              {t('Classic view')}
              <Icon icon={ICON.UNDO} />
            </>
          )}
          onClick={() => backToThePast()}
        />
        {isImpersonating && (
          <div className="Header__impersonating">
            {t('Impersonating {{name}}', { name: user.name || user.username })}
            <button type="button" onClick={stopImpersonating}>{t('Stop')}</button>
          </div>
        )}
      </div>
      <div className="Header__right">
        <UserProfileWidget />
        {isAdmin && <AdminToolsWidget />}
        <LangSelect />
      </div>
    </div>
  )
}

export default Header
